import { IDashboardState } from "@/apps/dashboard/models/IDashboardState";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  namespaced: true,
  state: {
    user: {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      locale: null,
      selectedCompany: {
        companyId: null,
        companyName: null,
        country: null,
        roles: [],
      },
      userRequiresTwoFactor: null,
      twoFactorEnrolled: null,
      emailHash: null,
    },
  } as IDashboardState,

  mutations,
  actions,
  getters,
};
